import { createVNode as _createVNode } from "vue";
import "core-js/modules/es.array.push.js";
import { defineComponent, reactive, watch, onMounted } from "vue";
import _ from "lodash";
import { useRouter } from "vue-router";
// config
import { navList } from "@/config/common";
// components

export default defineComponent({
  name: "PCNavBar",
  setup() {
    // 组件状态
    const state = reactive({
      activeIndex: null
    });
    const router = useRouter();

    // 获取当前选中
    function getAct(url) {
      navList.find(item => {
        const list = item.url;
        if (list.includes(url)) {
          state.activeIndex = item.status;
          document.getElementById("container-id").scrollTop = 0;
        }
      });
    }
    onMounted(() => {
      const nowUrl = location.hash.length > 2 ? location.hash.slice(1, location.hash.indexOf("?")) : "/";
      getAct(nowUrl);
    });

    // 监听路由变化
    watch(() => router.currentRoute.value.path, val => {
      getAct(val);
    });
    const handleClick = item => {
      state.activeIndex = item.status;
      item.url && router.push(item.url[0]);
    };
    return () => {
      const builtNavItem = _.map(navList, item => {
        return _createVNode("div", {
          "class": "nav-img",
          "onClick": () => handleClick(item)
        }, [_createVNode("img", {
          "class": "img",
          "src": require(`@/assets/img/pc/homePage/${item.pcImg}${state.activeIndex === item.status ? "-act" : ""}.png`)
        }, null)]);
      });
      return _createVNode("div", {
        "class": "nav-bar"
      }, [_createVNode("div", {
        "class": "inner"
      }, [builtNavItem])]);
    };
  }
});